import React from "react";

const MotivationTabContent = ({ initialData, setMotivation }) => {
  const data = initialData || {}; // Ensure data is an object

  return (
    <div className="space-y-5">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Мотивация 1
        </label>
        <textarea
          name="motivation1"
          defaultValue={data.motivation1 || ""}
          rows="2"
          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          onChange={(e) =>
            setMotivation((prev) => ({
              ...prev,
              motivation1: e.target.value,
            }))
          }
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Мотивация 2
        </label>
        <textarea
          name="motivation2"
          defaultValue={data.motivation2 || ""}
          rows="2"
          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          onChange={(e) =>
            setMotivation((prev) => ({
              ...prev,
              motivation2: e.target.value,
            }))
          }
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Мотивация 3
        </label>
        <textarea
          name="motivation3"
          defaultValue={data.motivation3 || ""}
          rows="2"
          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          onChange={(e) =>
            setMotivation((prev) => ({
              ...prev,
              motivation3: e.target.value,
            }))
          }
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Мотивация 4
        </label>
        <textarea
          name="motivation4"
          defaultValue={data.motivation4 || ""}
          rows="2"
          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          onChange={(e) =>
            setMotivation((prev) => ({
              ...prev,
              motivation4: e.target.value,
            }))
          }
        />
      </div>
    </div>
  );
};

export default MotivationTabContent;